import styled from 'styled-components';

export const StyledHeightController = styled.div`
  margin-top: ${({ $itemRelativeHeight }) => $itemRelativeHeight}%;
  width: 100%;
`;
